import _ from 'lodash'
import dayjs from 'dayjs'
import { jwtDecode } from 'jwt-decode'
import { createStore } from 'zustand/vanilla'
import { setCookie } from 'cookies-next/client'
import { Cruz } from '@cruz-com/lookup'
import { Toast } from '@/types'

type SpottedFilter = {
  page_size?: number
  sort_id?: number
}

type VehicleFilter = {
  page_size?: number
  sort_id?: number
  zip_code?: string
  radius?: number
}

type ModalSignIn = {
  show: boolean
  saveVehicleId?: string | null
  like?: {
    name: string
    id: string
  }
  saveSearch?: boolean
}

export type GlobalState = {
  user: Cruz.User | null,
  toast?: Toast | null
  refreshMyProfile?: boolean
  spottedFilter?: SpottedFilter
  vehicleFilter?: VehicleFilter
  showSignIn?: boolean
  modalSignIn?: ModalSignIn
  leadType: number
  scrollTopOver: boolean
  showFeedback: boolean
}

export type GlobalActions = {
  setUser: (user: Cruz.User | null, pathname: string | null) => void
  setToast: (toast: Toast | null) => void
  setRefreshMyProfile: (refreshMyProfile: boolean) => void
  setSpottedFilter: (spottedFilter: SpottedFilter) => void
  setVehicleFilter: (vehicleFilter: SpottedFilter) => void
  setModalSignIn: (modalSignIn: ModalSignIn) => void
  setLeadType: (leadType: number) => void
  setScrollTopOver: (scrollTopOver: boolean) => void
  setShowFeedback: (showFeedback: boolean) => void
}

export type GlobalStore = GlobalState & GlobalActions

export const createGlobalStore = (initState: GlobalState = { user: null, toast: null, leadType: 0, scrollTopOver: false, showFeedback: false }) => {
  return createStore<GlobalStore>()((set) => ({
    ...initState,
    setUser: async (user) => {
      if (user?.refresh_token) {
        setCookie('refresh_token', user.refresh_token, { expires: dayjs().add(1, 'year').toDate() })
      }
      if (user?.access_token) {
        const decoded = jwtDecode(user.access_token)
        if (decoded.exp) {
          setCookie('access_token', user.access_token, { expires: new Date(decoded.exp * 1000) })
        }
      }
      set({ user: _.omit(user, ['refresh_token', 'access_token']) })
    },
    setToast: (toast) => {
      set({ toast })
    },
    setRefreshMyProfile: (refreshMyProfile) => {
      set({ refreshMyProfile })
    },
    setSpottedFilter: (spottedFilter) => {
      const d = _.pick(spottedFilter, ['page_size', 'sort_id'])
      set({ spottedFilter: d })
      setCookie('spotted_filter', JSON.stringify(d), { expires: dayjs().add(1, 'year').toDate() })
    },
    setVehicleFilter: (vehicleFilter) => {
      const d = _.pick(vehicleFilter, ['page_size', 'sort_id', 'zip_code', 'radius'])
      set({ vehicleFilter: d })
      setCookie('vehicle_filter', JSON.stringify(d), { expires: dayjs().add(1, 'year').toDate() })
    },
    setModalSignIn: (modalSignIn) => {
      set({ modalSignIn })
    },
    setLeadType: (leadType) => {
      set({ leadType })
    },
    setScrollTopOver: (scrollTopOver) => {
      set({ scrollTopOver })
    },
    setShowFeedback: (showFeedback) => {
      set({ showFeedback })
    },
  }))
}
